import { Component } from "react"


/* Component Avatar — a photo in a frame. A photo which the browser could not load leaves the
   frame to what stands under it: the icon of a point or the letter of a name, and never the
   broken picture of the browser itself */
class Avatar extends Component {

    constructor() {
        super()

        this.state = {
            failed: false
        }
    }

    componentDidUpdate = previous => {

        /* Another photo is given a chance of its own */
        if (previous.src !== this.props.src && this.state.failed) {
            this.setState({ failed: false })
        }
    }

    render = () => {

        /* Fields */
        const { src, alt, className, children } = this.props
        const { failed } = this.state

        return (
            <div className={className}>
                {src && !failed
                    ? <img src={src} alt={alt} onError={() => this.setState({ failed: true })} />
                    : children
                }
            </div>
        )
    }
}

export default Avatar
